define('modules/editor/models/elements/html',['require','exports','module','./base','modules/includes_editor/index'],function(require, exports, module) {
  "use strict";
  var BaseElement = require("./base"),
      HtmlEditorService = require("modules/includes_editor/index");

  var HtmlElement = BaseElement.extend({
    name: "element:html",
    defaultNameKey:"html",
    defaultPropertyGroups: [],
    propertyGroups: [
      {
        name: "geometry",
        defaults: {
          width: 250,
          height: 250
        }
      },
      {
        name: "idclass",
        defaults: {
          "id": "",
          "className": ""
        }
      },
      {
        name: "html:content",
        defaults: {
          content: ""
        }
      }
    ],
    editHtml: function(){
      var htmlContent = this.getPropertyGroup("html:content").get("content");
      HtmlEditorService.editHtml(htmlContent, _.bind(this.saveHtmlContent, this));
    },

    saveHtmlContent: function(results){
      this.getPropertyGroup("html:content").set("content", results);
    }

  });

  module.exports = HtmlElement;
});

